import { alphaNumericValidator } from "src/app/modules/shared/validators/alpha-numeric.validator";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ListService } from "./list.service";
import { TitleCasePipe } from "@angular/common";
import { ConfirmationService, MessageService } from "primeng/api";
import { CustomService } from "../custom.service";
import { AppMainComponent } from "src/app/app.main.component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import data from "../../staticJSON/customfield.json";
import { AddYearPipe } from "src/app/shared/pipes/add-year.pipe";
import { ObjectNames, Status, FormControl, Severity, Answer, CommonCustomAttributes } from "../../constants/constants";
import { SectionService } from "../section/section.service";
import { Subscription } from "rxjs";
import { FormControlListIds } from "src/app/modules/shared/constants/formcontrol-list.constants";

@Component({
    selector: "app-list",
    templateUrl: "./list.component.html",
    styleUrls: ["./list.component.scss"],
})
export class ListComponent implements OnInit, OnDestroy {

    @Input() moduleList = [];
    allCustomFields = [];
    loading: boolean = true; // Initially true to show spinner before API call
    isAdd: boolean = false;
    customFieldData = [];
    inventoryObjId: any;
    allModules = [];
    allCustomFieldTypes = [];
    displayAddEditCustomField: boolean = false;
    customFieldNameExist: boolean = false;
    allSections = [];
    sections = [];
    showCustomFieldValidation: boolean = false;
    showOptionValidationError: boolean = false;
    allLevels = [];
    allTypes = [];
    allCategories = [];
    showAllCustomFieldTypes: any = [];
    isCustomFieldAdd: boolean = false;
    isCustomFieldEdit: boolean = false;
    addEditCustomFieldHeader;
    seletedCustomField;
    customFieldForm: FormGroup;
    addNewOptionForm: FormGroup;
    pickListValues = [];
    displayAddNewOption: boolean = false;
    addEditOptionHeader;
    statusConstants = Status;
    answertypeConstants = Answer;
    formControls = FormControl;
    allTemplates = [];
    selectedModule;

    constructor(
        private listService: ListService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private app: AppMainComponent,
        private customService: CustomService,
        private fb: FormBuilder,
        private yearPipe: AddYearPipe,
        private titlecasePipe: TitleCasePipe,
        private sectionService: SectionService,
    ) { }

    getCustomSubscription: Subscription;

    ngOnInit(): void {
        this.customService.getCustom().subscribe((custom) => {
            if (custom) {
                this.showAddCustomFieldPopUp();
            }
        });
        this.customFieldForm = this.fb.group({
            id: [0],
            createdSource: [this.app.userIP],
            updatedSource: [this.app.userIP],
            createdBy: [this.app.user.userId],
            updatedBy: [this.app.user.userId],
            createdDate: [new Date().toISOString()],
            updatedDate: [new Date().toISOString()],
            organizationId: [this.app.companyId],
            objectId: [""],
            section: ["", Validators.required],
            typeId: ["", Validators.required],
            formControlId: ["", Validators.required],
            title: [""],
            description: [""],
            fieldName: ["", [Validators.required, alphaNumericValidator()]],
            fieldId: [""],
            dataType: [""],
            length: [0],
            displayInModule: [""],
            isRequired: [false],
            isDisplayForWeb: [false],
            isDisplayForMobile: [false],
            isDisplayForQuestionnaire: [false],
            statusId: [Status.ACTIVE],
            isValid: [true],
            validFromDate: [new Date().toISOString()],
            validToDate: [this.yearPipe.transform(new Date())],
            pickListValues: [],
            maxLengthAfterDecimal: [null, [Validators.min(1), Validators.max(6)]],
        });

        this.getAllCats();
        this.getLevels();
        this.getTypes();
        this.sectionService.getSection().subscribe((section) => {
            this.getModules();
        });
    }

    changeModule() {
        this.customFieldForm.controls["objectId"].setValue(this.selectedModule);
        // this.getCustomFieldTypes();
        this.customFieldData = [];
        this.allCustomFields = [];
        this.getConfigurationTypes();
    }

    getCustomFieldTypes(action?) {
        const newFields = [
            FormControlListIds.MultiLine,
            FormControlListIds.Email,
            FormControlListIds.Phone,
            FormControlListIds.URL,
            FormControlListIds.IPAddress,
            FormControlListIds.DateTimePicker,
            FormControlListIds.AutoNumber,
            FormControlListIds.Lookup,
            FormControlListIds.UserLookup,
            FormControlListIds.Time,
            FormControlListIds.Formula,
            FormControlListIds.EncryptedText,
            FormControlListIds.RichText,
            FormControlListIds.Barcode
        ];

        this.listService.getAllCustomFieldTypes(this.selectedModule.id).then((fldtyps) => {
            this.allCustomFieldTypes = fldtyps;
            if (!action) {
                this.loadCustomFields();
            }
            if (this.customFieldForm.controls["objectId"].value.name == ObjectNames.OrdersConstants.orderFieldName) {
                this.showAllCustomFieldTypes = fldtyps.filter((el) => el.isShow && ![...newFields, FormControlListIds.Currency, FormControlListIds.Percentage].includes(el.id));
            } else {
                this.showAllCustomFieldTypes = fldtyps.filter((el) => el.isShow && !newFields.includes(el.id));
            }
            this.showAllCustomFieldTypes.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        });
    }

    getConfigurationTypes(action?) {
        if (this.customFieldForm.controls["objectId"].value.name == ObjectNames.OrdersConstants.orderFieldName) {
            const fieldNameControl = this.customFieldForm.controls["maxLengthAfterDecimal"];
            if (fieldNameControl) {
                fieldNameControl.clearValidators();
                fieldNameControl.updateValueAndValidity();
            }
            this.sectionService.getAllTypes().subscribe((types) => {
                const channelTypeId = types.filter((type) => type.name == ObjectNames.OrdersConstants.Orders_Submodule_TypeName)[0].id;
                const sectionTypeId = types.filter((type) => type.name == ObjectNames.customConstants.Inventory_Section_TypeName)[0].id;
                this.loadConfigurations(channelTypeId, sectionTypeId, action);
            });
        } else if (this.customFieldForm.controls["objectId"].value.name == ObjectNames.purchaseOrderConstants.purchaseFieldName) {
            this.sectionService.getAllTypes().subscribe((types) => {
                const channelTypeId = types.filter((type) => type.name == ObjectNames.purchaseOrderConstants.Purchase_Submodule_TypeName)[0].id;
                const sectionTypeId = types.filter((type) => type.name == ObjectNames.customConstants.Inventory_Section_TypeName)[0].id;
                this.loadConfigurations(channelTypeId, sectionTypeId, action);
            });
        } else {
            this.sectionService.getAllTypes().subscribe((types) => {
                const channelTypeId = types.filter((type) => type.name == ObjectNames.productConstants.Inventory_Types_TypeName)[0].id;
                const sectionTypeId = types.filter((type) => type.name == ObjectNames.customConstants.Inventory_Section_TypeName)[0].id;
                this.loadConfigurations(channelTypeId, sectionTypeId, action);
            });
        }
        this.getCustomFieldTypes(action);
    }

    loadConfigurations(typeId, sectionId, action?) {
        if (this.customFieldForm.controls["objectId"].value.name == ObjectNames.OrdersConstants.orderFieldName) {
            this.sectionService.getConfigurationsByModuleName("Order").subscribe((configs) => {
                const typeConfig = configs.filter((s) => s.name == ObjectNames.OrdersConstants.Orders_Submodule_Object && s.typeId == typeId)[0];

                /**
                 * to make estimates, salesorder and invoice as a single option
                 */
                const orderTemplates = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
                const res = [];
                orderTemplates.forEach((element) => {
                    if (element.name == "Customers" || element.name == "Customer Returns" || element.name == "Credit Memo" || element.name == "Sales Receipt") {
                        res.push(element);
                    }
                });
                res.push(CommonCustomAttributes);
                this.allTemplates = res;
                const sectionConfig = configs.filter((s) => s.name == ObjectNames.customConstants.Order_Section_Object && s.typeId == sectionId)[0];
                this.allSections = JSON.parse(sectionConfig.configurationDetails[0].configJSONValue);
                if (action == 'edit') {
                    const filteredType = this.allTemplates.filter((type) => type.id == this.seletedCustomField?.section?.typeId)[0];
                    this.customFieldForm.controls["typeId"].setValue(filteredType);
                    this.loadTypewiseSections(filteredType, action);
                }
            });
        } else if (this.customFieldForm.controls["objectId"].value.name == ObjectNames.purchaseOrderConstants.purchaseFieldName) {
            this.sectionService.getConfigurationsByModuleName("Purchase").subscribe((configs) => {
                const typeConfig = configs.filter((s) => s.name == ObjectNames.purchaseOrderConstants.Purchase_Submodule_Object && s.typeId == typeId)[0];
                const allTemplates = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
                this.allTemplates = allTemplates.filter(item => !['Item Receipt', 'Bill'].includes(item.name));
                const sectionConfig = configs.filter((s) => s.name == ObjectNames.customConstants.Purchase_Section_Object && s.typeId == sectionId)[0];
                this.allSections = JSON.parse(sectionConfig.configurationDetails[0].configJSONValue);
                if (action == 'edit') {
                    const filteredType = this.allTemplates.filter((type) => type.id == this.seletedCustomField?.section?.typeId)[0];
                    this.customFieldForm.controls["typeId"].setValue(filteredType);
                    const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                    this.customFieldForm.controls["section"].setValue(filteredSection);
                    this.loadTypewiseSections(filteredType, action);
                }
            });
        } else {
            this.sectionService.getConfigurationsByModuleName("product").subscribe((configs) => {
                const typeConfig = configs.filter((s) => s.name == ObjectNames.productConstants.Inventory_Types_Object && s.typeId == typeId)[0];
                this.allTemplates = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
                const sectionConfig = configs.filter((s) => s.name == ObjectNames.customConstants.Inventory_Section_Object && s.typeId == sectionId)[0];
                this.allSections = JSON.parse(sectionConfig.configurationDetails[0].configJSONValue);
                if (action == 'edit') {
                    const filteredType = this.allTemplates.filter((type) => type.id == this.seletedCustomField?.section?.typeId)[0];
                    this.customFieldForm.controls["typeId"].setValue(filteredType);
                    const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                    this.customFieldForm.controls["section"].setValue(filteredSection);
                    this.loadTypewiseSections(filteredType, action);
                }
            });
        }
    }

    loadTypewiseSections(data, action?) {
        const typeId = data?.id;
        this.customFieldForm.controls["section"].setValue(null);
        /**
         * If selected module is Orders, then custom field can be created for combined templates except Customerreturns,Customers
         */
        if (this.customFieldForm.controls["objectId"].value?.name == ObjectNames.OrdersConstants.orderFieldName) {
            if (data?.name == "Customers" || data?.name == "Credit Memo") {
                this.sections = this.allSections.filter((section) => section.typeId == typeId && section.isActive && section?.code != "labels_footer" && section?.code != "labels_table");
                if (action == 'edit') {
                    const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                    this.customFieldForm.controls["section"].setValue(filteredSection);
                }
            } else if (data?.name == "Customer Returns") {
                this.sections = this.allSections.filter((section) => section.typeId == typeId && section.isActive && ObjectNames.OrdersConstants.RMA_CustomSectionCode?.includes(section.code));
                if (action == 'edit') {
                    const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                    this.customFieldForm.controls["section"].setValue(filteredSection);
                }
            } else if (data?.name == "Sales Receipt") {
                this.sections = this.allSections.filter((section) => section.typeId == typeId && section.isActive);
                this.sections = this.allSections.filter((section) => section.typeId == typeId && section.isActive && section?.code != "labels_account" && section?.code != "labels_table");
                if (action=='edit') {
                    const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                    this.customFieldForm.controls["section"].setValue(filteredSection);
                }
            } else {
                this.sections = this.allSections.filter(
                    (section) => section.typeId == 0 && section.isActive && section?.code != "labels_footer" && section?.code != "labels_table", // typeId = 0 for combined templates estimates, salesorder and invoice
                );
                if (action == 'edit') {
                    const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                    this.customFieldForm.controls["section"].setValue(filteredSection);
                }
            }
        } else if (this.customFieldForm.controls["typeId"].value?.name == "Bill Payment" || this.customFieldForm.controls["typeId"].value?.name == "Vendor Returns") {
            this.sections = this.allSections.filter((section) => section.typeId == typeId && section.isActive && section.isAvailable);
            if (action == 'edit') {
                const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                this.customFieldForm.controls["section"].setValue(filteredSection);
            }
        } else {
            this.sections = this.allSections.filter((section) => section.typeId == typeId && section.isActive
                && section?.code != "labels_footer" && section?.code != "labels_table");
            if (action == 'edit') {
                const filteredSection = this.sections.filter((section) => section.id == this.seletedCustomField?.section?.id)[0];
                this.customFieldForm.controls["section"].setValue(filteredSection);
            }
            const priceTierSection = this.sections.filter((s) => s.name == "Price Tier")[0];
            const index = this.sections.indexOf(priceTierSection);
            this.sections.splice(index, 1);
        }
    }

    filterFieldType(data) {
        const formControlId = data.name;
        this.allCustomFields = this.allCustomFields.filter((field) => field.formControl.name == formControlId);
    }

    showAddCustomFieldPopUp() {
        this.isAdd = true;
        this.pickListValues = [];
        this.sections = [];
        this.showCustomFieldValidation = false;
        this.customFieldForm = this.fb.group({
            id: [this.allCustomFields.length + 1],
            createdSource: [this.app.userIP],
            updatedSource: [this.app.userIP],
            createdBy: [this.app.user.userId],
            updatedBy: [this.app.user.userId],
            createdDate: [new Date().toISOString()],
            updatedDate: [new Date().toISOString()],
            organizationId: [this.app.companyId],
            objectId: [this.selectedModule, Validators.required],
            section: ["", Validators.required],
            typeId: ["", Validators.required],
            formControlId: ["", Validators.required],
            title: [""],
            description: [""],
            fieldName: ["", [Validators.required, alphaNumericValidator()]],
            fieldId: [""],
            dataType: [""],
            length: [0],
            displayInModule: [""],
            isRequired: [false],
            isDisplayForWeb: [false],
            isDisplayForMobile: [false],
            isDisplayForQuestionnaire: [false],
            statusId: [Status.ACTIVE],
            isValid: [true],
            validFromDate: [new Date().toISOString()],
            validToDate: [this.yearPipe.transform(new Date())],
            pickListValues: [],
            maxLengthAfterDecimal: [null, [Validators.min(1), Validators.max(6)]],
        });
        this.getConfigurationTypes('add');
        this.displayAddEditCustomField = true;
        this.isCustomFieldAdd = true;
        this.addEditCustomFieldHeader = ObjectNames.productConstants.AddCustomTitle;
    }

    getLevels() {
        this.listService.getAllLevels().then((levels) => {
            this.allLevels = levels;
        });
    }

    getTypes() {
        this.listService.getAllTypes().then((types) => {
            this.allTypes = types;
        });
    }

    getAllCats() {
        this.listService.getAllCategories().then((cates) => {
            this.allCategories = cates;
        });
    }

    getModules() {
        this.listService.getAllModules().subscribe((modules) => {
            this.allModules = modules.filter((obj) => obj.name == ObjectNames.productConstants.productFieldName || obj.name == ObjectNames.purchaseOrderConstants.purchaseFieldName || obj.name == ObjectNames.OrdersConstants.orderFieldName);
            if (!this.selectedModule) {
                this.selectedModule = this.allModules[0];
            }
            this.getCustomFieldTypes();
            //this.getConfigurationTypes();
        });
    }

    loadCustomFields() {
        this.loading = true; // Start loading before API call

        this.listService.getAllCustomFields(this.selectedModule?.id).then((fields) => {
            this.allCustomFields = [];
            this.customFieldData = [];

            if (!fields || fields.length === 0) {
                // API returned 204 No Content or empty array
                this.loading = false;
                return;
            }

            this.customFieldData = fields.map((l) => ({
                id: Number(l.id),
                name: l.name,
                module: this.allModules.find((el) => el.id == l.objectId)?.name || 'Unknown',
                formControl: l.formControl,
                isRequired: l.isRequired,
                statusId: l.statusId,
                statusName: l.status?.name || 'N/A',
                section: l.section,
                configurationId: l.configurationId,
                isEdit: l.isEdit,
                isDelete: l.isDelete,
            }));

            this.allCustomFields = [...this.customFieldData].sort((a, b) => a.name.localeCompare(b.name));
        }).catch((error) => {
            console.error('Error loading custom fields:', error);
        }).finally(() => {
            this.loading = false; // Stop loading after API call (success or failure)
        });
    }


    async showEditCustomFieldPopUp(field) {
        this.pickListValues = [];
        this.isAdd = false;
        this.showCustomFieldValidation = false;
        this.seletedCustomField = field;
        const resp = await this.listService.getCustomFieldById(field.id, this.selectedModule?.name);
        let customFieldValue = resp;
        this.customFieldForm.patchValue(customFieldValue);
        this.customFieldForm.controls["objectId"].setValue(this.allModules.find((el) => el.id == customFieldValue.objectId));

        this.customFieldForm.controls["formControlId"].setValue(this.allCustomFieldTypes.find((el) => el.id == customFieldValue.formControlId));
        this.getConfigurationTypes('edit');
        if (customFieldValue?.pickListValues !== null && customFieldValue?.pickListValues !== undefined) {
            const pickUpList = JSON.parse(customFieldValue?.pickListValues);
            if (pickUpList?.length > 0) {
                this.pickListValues = pickUpList;
            }
        }
        this.addEditCustomFieldHeader = ObjectNames.productConstants.EditCustomTitle;
        this.isCustomFieldEdit = true;
        this.isCustomFieldAdd = false;
        this.displayAddEditCustomField = true;
        const fieldNameControl = this.customFieldForm.controls["fieldName"];
        if (fieldNameControl) {
            fieldNameControl.setValidators([Validators.required]);
            fieldNameControl.updateValueAndValidity();
        }
    }

    deleteCustomField(field) {
        const reqData = {
            fieldId: field.id,
            moduleId: this.selectedModule.id,
        };

        this.confirmationService.confirm({
            message: "Do you want to delete this custom field?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            key: "delete-custom-field",
            accept: () => {
                this.listService
                    .deleteCustomField(reqData)
                    .then(() => {
                        this.messageService.add({
                            severity: Severity.Success,
                            summary: this.titlecasePipe.transform(Severity.Success),
                            detail: "Deleted successfully...",
                        });
                        this.loadCustomFields();
                    })
                    .catch((err) => {
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: err.error.Message,
                        });
                    });
            },
            reject: () => { },
        });
    }

    addOptionList() {
        this.pickListValues.push({ name: "" });
    }

    deleteCustomOption(index) {
        this.pickListValues.splice(index, 1);
    }

    resetPickList(event) {
        this.pickListValues = [];
        const maxLengthAfterDecimal = event.value.id == this.formControls.Decimal ? event.value.maxLengthAfterDecimal || 2 : null;
        this.customFieldForm.patchValue({
            maxLengthAfterDecimal: maxLengthAfterDecimal,
        });
    }

    checkPickListValues() {
        let showerr = false;
        this.pickListValues.forEach((option) => {
            showerr = !option.name;
        });
        return showerr;
    }

    checkCustomFieldVAlidation(value) {
        let showerror = false;
        this.showOptionValidationError = false;
        const checkDuplicateName = this.allCustomFields.some((el) => el.name.trim() == value.fieldName.trim());
        if (!value.fieldName || (this.isCustomFieldAdd && checkDuplicateName) || !value.objectId || !value.formControlId || !value.section || (this.pickListValues && this.pickListValues.length > 0 && this.checkPickListValues())) {
            if (this.isCustomFieldAdd && checkDuplicateName) {
                this.customFieldNameExist = true;
            }
            showerror = true;
        } else if ((value.formControlId.id == FormControl.Dropdown && this.pickListValues.length == 0) || (value.formControlId.id == FormControl.Checkbox && this.pickListValues.length == 0) || (value.formControlId.id == FormControl.RadioButton && this.pickListValues.length < 2) || (value.formControlId.id == FormControl.MultiSelect && this.pickListValues.length == 0)) {
            showerror = true;
            this.showOptionValidationError = true;
        } else if (value.formControlId.id == FormControl.Decimal && !value.maxLengthAfterDecimal) {
            this.showOptionValidationError = true;
            showerror = true;
        }
        return showerror;
    }

    checkDuplicatePickListValue(): boolean {
        if (!this.pickListValues) return false;
        const seen = new Set<string>();
        for (const item of this.pickListValues) {
            const name = item?.name?.trim().toLowerCase();
            if (!name) continue;
            if (seen.has(name)) return true; // Duplicate found
            seen.add(name);
        }
        return false; // No duplicates
    }


    saveCustomFieldData(value) {
        const formControlArray = [this.formControls.Dropdown, this.formControls.Checkbox, this.formControls.RadioButton,
         this.formControls.MultiSelect];
        if (formControlArray.includes(this.customFieldForm.controls['formControlId'].value.id) && this.checkDuplicatePickListValue()) {
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Duplicate PickList values found...",
            });
            return;
        }
        const selectedTemplateId = this.customFieldForm.controls["typeId"].value?.id;
        if (this.checkCustomFieldVAlidation(value)) {
            this.showCustomFieldValidation = true;
        } else {
            const module = value.objectId;
            this.customFieldNameExist = false;
            this.showOptionValidationError = false;
            this.showCustomFieldValidation = false;
            value.fieldName = value.fieldName.trim();
            value.objectId = value.objectId?.id;
            if (!this.isCustomFieldAdd) {
                value.formControl = value.formControlId;
            }
            value.formControlId = value.formControlId?.id;
            value.section = {
                id: value.section?.id,
                name: value.section?.name,
                typeId: value.typeId?.id,
                typename: selectedTemplateId == 0 ? "" : value.typeId?.name,
                code: value.section?.code,
            };
            value.pickListValues = JSON.stringify(this.pickListValues);
            delete value["typeId"];
            const customFieldConfigTemp = data;
            (customFieldConfigTemp.createdSource = this.app.userIP), (customFieldConfigTemp.updatedSource = this.app.userIP), (customFieldConfigTemp.createdBy = this.app.user.userId), (customFieldConfigTemp.updatedBy = this.app.companyId), (customFieldConfigTemp.createdDate = new Date().toISOString()), (customFieldConfigTemp.updatedDate = new Date().toISOString()), (customFieldConfigTemp.organizationId = this.app.user.organizationId), (customFieldConfigTemp.configJSONValue = JSON.stringify(value)), (customFieldConfigTemp.name = module.name == ObjectNames.productConstants.productFieldName ? ObjectNames.productConstants.productcustomFieldName : module.name == ObjectNames.purchaseOrderConstants.purchaseFieldName ? ObjectNames.purchaseOrderConstants.purchasecustomFieldName : ObjectNames.OrdersConstants.ordercustomFieldName);
            (customFieldConfigTemp.objectId = value.objectId), (customFieldConfigTemp.levelId = this.allLevels.find((el) => el.name == ObjectNames.productConstants.levelName)?.id), (customFieldConfigTemp.levelRecordId = this.app.user.organizationId), (customFieldConfigTemp.categoryId = module.name == ObjectNames.productConstants.productFieldName ? this.allCategories.find((el) => el.name == ObjectNames.productConstants.productcustomFieldName)?.id : module.name == ObjectNames.purchaseOrderConstants.purchaseFieldName ? this.allCategories.find((el) => el.name == ObjectNames.purchaseOrderConstants.purchasecustomFieldName)?.id : this.allCategories.find((el) => el.name == ObjectNames.productConstants.productcustomFieldName)?.id), (customFieldConfigTemp.statusId = Status.ACTIVE), (customFieldConfigTemp.typeId = this.allTypes.find((el) => el.name == ObjectNames.productConstants.customFieldName)?.id);
            customFieldConfigTemp.maxLengthAfterDecimal = value.maxLengthAfterDecimal;

            if (this.isCustomFieldAdd) {
                this.listService.addCustomFieldsConfiguration(customFieldConfigTemp).then(() => {
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Custom Field added successfully...",
                    });
                    this.displayAddEditCustomField = false;
                    this.getCustomFieldTypes();
                });
            } else {
                customFieldConfigTemp.id = this.seletedCustomField.id;
                this.listService.updateCustomFieldsConfiguration(customFieldConfigTemp).then(() => {
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Custom Field updated successfully...",
                    });
                    this.displayAddEditCustomField = false;
                    this.getCustomFieldTypes();
                });
            }
        }
    }

    ngOnDestroy(): void {
        this.customService.setCustom("");
    }
}
